import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
function NotFound(){
    const { name } = useParams();
    return(
        <main className="text-center">
            <p className="text-3xl pt-20">
                Nie znaleziono takiej strony
            </p>
            <p>Wróć do strony głównej</p>
            <Link className="text-blue-500 underline" to={`/${name}`}>Strona główna</Link>
        </main>
    )
}

export default NotFound;
